export default {
  zh: {
    search: '查找文件夹',
    new: '新文件夹',
    tabs: {
      reports: '报告文件夹',
      dashboards: 'Dashboard文件夹',
    },
  },
  en: {
    search: 'Search Folder',
    new: 'New Folder',
    tabs: {
      reports: 'Reports',
      dashboards: 'Dashboards',
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/ReportListSider/i18n.js